import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "searchInput", "submit"]

  connect() {
    this.initialStates = new Map(this.checkboxTargets.map((checkbox) => [checkbox.value, checkbox.checked]))
    this.updateSubmitButton()
  }

  search() {
    const query = this.searchInputTarget.value.toLowerCase()

    this.checkboxTargets.forEach((checkbox) => {
      const label = checkbox.closest("label")
      const text = label.textContent.toLowerCase()

      label.classList.toggle("hidden", !text.includes(query))
    })
  }

  toggleCheckbox() {
    this.updateSubmitButton()
  }

  clearCheckbox() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const hasChanges = this.checkboxTargets.some((checkbox) => this.initialStates.get(checkbox.value) !== checkbox.checked)
    this.submitTarget.disabled = !hasChanges
  }
}
